import React, { useEffect, useRef, useState } from "react";

export default function Roadmap() {
  const svgHostRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const tpl = document.getElementById("roadmap-svg-template");
    if (!tpl) {
      const msg =
        "Missing <template id='roadmap-svg-template'>. " +
        "Put your Liquid-rendered SVG inside that template in the page HTML.";
      console.error(msg);
      setError(msg);
      return;
    }

    if (svgHostRef.current && svgHostRef.current.childNodes.length === 0) {
      svgHostRef.current.appendChild(tpl.content.cloneNode(true));
    }

    // Load roadmap.js
    const SCRIPT_ID = "roadmap-app-script";
    const scriptSrc = "/assets/roadmap/roadmap.js";
    if (!document.getElementById(SCRIPT_ID)) {
      const s = document.createElement("script");
      s.id = SCRIPT_ID;
      s.src = scriptSrc;
      s.defer = true;
      s.onerror = () => {
        const msg = `Failed to load "${scriptSrc}". Make sure it exists at that path.`;
        console.error(msg);
        setError(msg);
      };
      document.body.appendChild(s);
    }
  }, []);

  return (
    <main className="page">
      <h1 className="roadmap-heading">ITS Roadmap</h1>

      <div className="roadmap-controls">
        {/* Search */}
        <div className="roadmap-search">
          <label htmlFor="roadmapSearch" className="sr-only">
            Search milestones
          </label>

          <span className="roadmap-search-icon" aria-hidden="true">
            <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
              <circle cx="7" cy="7" r="4.5"></circle>
              <line x1="10.5" y1="10.5" x2="14" y2="14"></line>
            </svg>
          </span>

          <input
            id="roadmapSearch"
            type="search"
            placeholder="Search milestones..."
            aria-label="Search milestones"
          />

          <div
            id="roadmapSearchSuggestions"
            className="roadmap-search-suggestions"
            role="listbox"
            aria-label="Search suggestions"
          ></div>
        </div>

        <div className="year-dropdown">
          <button
            className="year-dropdown-btn"
            type="button"
            id="yearToggle"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span id="yearDropdownLabel">Year</span>
            <span className="year-dropdown-arrow" aria-hidden="true">
              ▾
            </span>
          </button>
          <div className="year-dropdown-menu" id="yearMenu">
          </div>
        </div>
      </div>

      {/* Error */}
      {error ? (
        <div style={{ padding: "12px 0", color: "#b00020", fontWeight: 600 }}>
          {error}
        </div>
      ) : null}

      {/* SVG host */}
      <div className="roadmap-wrap" ref={svgHostRef} />

      {/* Modal markup matching your index.html */}
      <div className="roadmap-modal-backdrop" id="roadmapModalBackdrop">
        <div
          className="roadmap-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="roadmapModalTitle"
        >
          <button className="roadmap-modal-close" type="button" aria-label="Close">
            &times;
          </button>
          <div id="roadmapModalTitle" className="roadmap-modal-title"></div>
          <div className="roadmap-modal-meta"></div>
          <div className="roadmap-modal-desc"></div>
          <img className="roadmap-modal-image" alt="" />
        </div>
      </div>
    </main>
  );
}
